/**
 * Common translation keys used across the permissions system.
 * These keys must match the keys in intl/locale/messages.*.json files.
 */
export const PermissionTranslationKeys = {
  /** Generic message when action is forbidden due to insufficient permissions */
  ACTION_FORBIDDEN: 'tooltip_action_forbidden',

  /** Message shown when action is unavailable in offline mode */
  OFFLINE_UNAVAILABLE: 'general_offline_operation_unavailable',
} as const;
